module.exports = __webpack_public_path__ + "img/pin-smc@3x.5b0cff2b.png";